/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
 governed by the Apache 2.0 license. */

import React, { FC } from 'react';
import styles from './styles.module.scss';

interface IProps {}

// eslint-disable-next-line no-empty-pattern
const RestocareFooter: FC<IProps> = ({}) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.wrap}>
      &copy;, {currentYear} Company IceRock Development
    </div>
  );
};

export { RestocareFooter };
